/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Voice_DroppedInputs */



/**
* | output |
* | --- |
* | "The connection to the conversation was lost. Finish up to see your feedback." |
*
* @param {Practice_Session_Voice_DroppedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_voice_dropped = /** @type {((inputs?: Practice_Session_Voice_DroppedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Voice_DroppedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De verbinding met het gesprek is weggevallen. Rond af om je feedback te bekijken.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La connexion à l'entretien a été perdue. Clôturez pour voir votre feedback.")
	return /** @type {LocalizedString} */ ("The connection to the conversation was lost. Finish up to see your feedback.")
});